import { useCallback, useState } from "react";
import { FlightAlertsService } from "../../../api/flightAlerts.service";
import { getDashErrorCode } from "./apiError.helper";
import { OtpOutcome } from "./useOtpSend";

export interface UseOtpVerifyResult {
  verifyOtp: (phoneNumber: string, code: string) => Promise<OtpOutcome>;
  isVerifying: boolean;
}

export const useOtpVerify = (): UseOtpVerifyResult => {
  const [isVerifying, setIsVerifying] = useState(false);

  const verifyOtp = useCallback(async (phoneNumber: string, code: string): Promise<OtpOutcome> => {
    setIsVerifying(true);
    try {
      const service = new FlightAlertsService();
      await service.verifyOtp(phoneNumber, code);
      return { success: true };
    } catch (err) {
      const errorCode = getDashErrorCode(err);
      return errorCode !== undefined ? { success: false, errorCode } : { success: false };
    } finally {
      setIsVerifying(false);
    }
  }, []);

  return { verifyOtp, isVerifying };
};
